import { getSeguroPromise } from '../../shared/helper/requests'
import { platform } from 'platformImpl';

const AVALIADOR_ERRO = "Erro da API de avaliação";
const AVALIADOR_ERRO_RESPONSE = "Erro na resposta da API de avaliação";

const AVALIADOR_MENSAGENS_ERRO = {
    400: "Não é possível avaliar o atendimento, tente mais tarde. (cod. 400)",
    401: "Serviço de Avaliação indisponível, favor tentar mais tarde. (cod 401)",
    403: "Serviço de Avaliação indisponível, favor tentar mais tarde. (cod 403)",
    404: "Serviço de Avaliação indisponível, favor tentar mais tarde. (cod 404)",
    410: "Foi detectada que uma avaliação já foi realizada para este serviço. Será possível avaliar novamente no futuro, por favor aguarde.(cod. 410)",
    500: "Serviço de Avaliação indisponível, favor tentar mais tarde. (cod 500)",
    503: "Serviço de Avaliação indisponível, favor tentar mais tarde. (cod 503)",
}

//DEFINIDA PELA API DO AVALIADOR
const CANAL = { web: 8, mobile: 1 }

export const obterLinkDireto = (cpf,servico) => {
    let canalPrestacao = platform.isWeb ? CANAL.web : CANAL.mobile;

    return [function(dispatch){ 
        dispatch(obterLinkDiretoSolicitado());
        return getSeguroPromise('avaliadorServices/obterLinkDiretoV2/'+cpf+"/"+servico+"/"+canalPrestacao)
            .then( response => {dispatch(obterLinkDiretoRecebido(response.data,servico))})
            .catch(falha => {dispatch(obterLinkDiretoErro(falha))});
    }, limparMensagem()]
}

const obterLinkDiretoSolicitado = ()=>({
    type: 'AVALIADOR_OBTER_LINK_DIRETO_SOLICITADO'
})

const obterLinkDiretoRecebido = (response, servico) => {
    let link = {};
    if(response && response.location){
        link[servico]=response.location;
        return {
            type:'AVALIADOR_OBTER_LINK_DIRETO_RECEBIDO',
            payload: link
        }
    } else {
        return {
            type:'AVALIADOR_OBTER_LINK_DIRETO_ERRO',
            payload: AVALIADOR_ERRO_RESPONSE
        }
    }
}

const obterLinkDiretoErro = (error) => {
    if (error && error.response && parseInt(error.response.status) === 410) {
        return {
            type:'AVALIADOR_OBTER_LINK_DIRETO_ERRO',
            payload: AVALIADOR_MENSAGENS_ERRO["410"],
            error: true
        }
    } else {
        if(error && error.response && error.response.data && error.response.data.result && AVALIADOR_MENSAGENS_ERRO[error.response.data.result]) {
            return {                
                type:'AVALIADOR_OBTER_LINK_DIRETO_ERRO',
                payload: AVALIADOR_MENSAGENS_ERRO[error.response.data.result],
                error: true
            }
        } else {
            return {
                type:'AVALIADOR_OBTER_LINK_DIRETO_ERRO',
                payload:AVALIADOR_ERRO,
                error: true
            }
        }
    }
}

//Limpa mensagens de Erro
export const limparMensagem = () => ({
    type: "AVALIADOR_LIMPAR_MENSAGEM"
})

//Reseta as avaliações
export const limparAvaliacoes = ()=>({
    type: 'AVALIADOR_LIMPAR_AVALIACOES'
});

export const redirecionarParaAvaliacaoLinkDireto = () => ({
    type:'AVALIADOR_REDERICIONAR_LINK_DIRETO'
});
